import MainRoutes from "./page/MainRoutes";
import Sidebar1 from "./components/SideBar1";
import { useEffect, useState } from "react";
import { addUserData } from "./redux/reducer/protectedRoutes";
import { fetchUserData, fetchUserDetails } from "./allApi/api";
import { useDispatch, useSelector } from "react-redux";
import ErrorHandleToast from "./components/ErrorComp/ErrorHnadleComp";
import MobileRestriction from "./components/MobileRestriction/MobileRestriction";
import AppLoader from "./components/loader/AppLoader1";
import { UserAuth } from "./Supabase/context/AuthContext";
import { Routes, Route, Navigate } from "react-router-dom";
import SignIn from "./Supabase/pages/SignIn";
import SignUp from "./Supabase/pages/SignUp";
import VerifyEmail from "./Supabase/pages/VerifyEmail";
import Welcome from "./Supabase/pages/Welcome";
import ForgotPassword from "./Supabase/pages/ForgotPassword";
import UpdatePassword from "./Supabase/pages/UpdatePassword";

import WorkflowCard from "./page/WorkFlowAdmin/Workflow";
function App() {
  const { session } = UserAuth();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);

  const user = session?.user; 

  const userFromDB = useSelector((state) => state?.protectedRoute?.userData);

  const token = session?.access_token || localStorage.getItem("token");

  useEffect(() => {
    if (session?.access_token) {
      localStorage.setItem("token", session.access_token);
      if (session.user?.email) {
        localStorage.setItem("user_mailId", session.user.email);
      }
      if (session.user?.user_metadata?.display_name) {
        localStorage.setItem("user_name", session.user.user_metadata.display_name);
      }
    }
  }, [session]);

  const getAndDispatchUserData = async (user, dispatch, setError) => {
    const baseInfo = user?.user_metadata || {};
    const basicUser = {
      name:
        baseInfo.display_name ||
        baseInfo.name ||
        baseInfo.full_name ||
        baseInfo.username ||
        "User",
      email: user?.email || "",
    };

    try {
      const fetchedData = await fetchUserData();
      dispatch(addUserData({ ...basicUser, ...fetchedData }));
    } catch (err) {
      dispatch(addUserData(basicUser));
      if (setError) {
        setError("Failed to fetch extended user data.");
      }
    }
  };

  useEffect(() => {
    if (token && user) {
      getAndDispatchUserData(user, dispatch, setError);
    }
  }, [token, user, dispatch]);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await fetchUserData();
        dispatch(addUserData(response));
      } catch (err) {
        setError("Failed to fetch user data");
      }
    };

    if (token) {
      getData();
    }
  }, [token, dispatch]);

  if (error) return <div>Error: {error}</div>;
  if (session === undefined) return <AppLoader />;

  return (
    <>
      <Routes>
        <Route path="/auth/verify-email" element={<VerifyEmail />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/update-password" element={<UpdatePassword />} />

        <Route
          path="*"
          element={
            token && session?.access_token && userFromDB?.isActive ? (
              <MobileRestriction>
                <Sidebar1>
                  <ErrorHandleToast />
                  <MainRoutes />
                </Sidebar1>
              </MobileRestriction>
            ) : (
              <Navigate to="/signin" replace />
            )
          }
        />
      </Routes>
    </>
  );
}

export default App;